import React from 'react';
import { useState, useContext, useEffect } from 'react';
import PermissionsGate from '../../../api/PermissionsGate';
import { SCOPES } from '../../../config/permissions-map';
import { Unauthorized } from '../../Global/unauthorized';
import { PageTitle } from '../../../../_metronic/layout/core';
import * as Utilities from '../../../Components/Utils/Utils';
import * as Api from '../../../api/Api';
import { useGetToken } from '../../../Hooks/CustomHooks';
import Modal from 'react-bootstrap/Modal';
import { FeedbackContext } from "../../../Components/Context/FeedbackContext";
import * as KeyNames from '../../../api/KeyNames';
import { useQuery } from 'react-query';
import { Loading } from '../../../Components/Loading/Loading';
import { SessionContext } from '../../../Components/Context/SessionContext';
import { ErrorConnection } from "../../../Components/Error/Error";
import UserIdAuthorized from '../../../api/UserIdAuthorized';

export default function GestionUsuariosLocatario({ title }) {

    const tokenn = useGetToken();
    const { session, setSession } = useContext(SessionContext);
    const idLocatario = (localStorage.getItem('idLocatario')) ? localStorage.getItem('idLocatario') : session.idUsuarioLocatario
    const { feedbackContext, setFeedbackContext } = useContext(FeedbackContext);

    const [dataGetUsuarios, setDataGetUsuarios] = useState({
        "administrador": {
            "correo": "",
            "nombreCompleto": "",
            "contrasenia": ""
        },
        "operador": {
            "correo": "",
            "nombreCompleto": "",
            "contrasenia": ""
        },
        "financiero1": {
            "correo": "",
            "nombreCompleto": "",
            "contrasenia": ""
        },
        "financiero2": {
            "correo": "",
            "nombreCompleto": "",
            "contrasenia": ""
        }
    })


    let { data: data1, isLoading: isLoading1, isError, error } = useQuery([KeyNames.SessionRespuesta,
    {
        idLocatario: idLocatario,
        token: tokenn
    }],
        async () => await Api.GetUsuarios_Locatario({
            api: "GetUsuarios_Locatario",
            idLocatario: idLocatario,
            token: tokenn
        }),
        { enabled: true });
    useEffect(() => {
        if (data1?.data) {
            if (!data1.success)
                setFeedbackContext({ ...feedbackContext, showError: true, idError: data1.errorId });
            else {
                setDataGetUsuarios(data1.data);
            }
        }
    }, [data1]);



    const [guardadoExitoso, setGuardadoExitoso] = useState(false);
    const [updateCierre, setUpdateCierre] = useState(false);


    let { data: data2, isLoading: isLoading2, isError: isError2 } = useQuery([KeyNames.SessionRespuesta,
    {
        dataUsuarios: dataGetUsuarios,
        idLocatario: idLocatario,
        token: tokenn
    }],
        async () => await Api.SetUsuarios_Locatario({ idLocatario: idLocatario, dataUsuarios: dataGetUsuarios, token: tokenn }),
        { enabled: Boolean(updateCierre) });
    useEffect(() => {
        if (data2) {
            if (!data2.success)
                setFeedbackContext({ ...feedbackContext, showError: true, isError2: data2.errorId });
            else {
                console.log(data2);
                setUpdateCierre(false);
                setGuardadoExitoso(true);
            }
        }
    }, [data2]);



    function guardadoExistosoModal() {
        setGuardadoExitoso(false);
        window.location.reload(false);
    }


    if (isLoading1) return (<Loading />)
    if (isError) return (<ErrorConnection error={error} />)

    return (
        <>
            <PermissionsGate RenderError={() => <Unauthorized />} scopes={[SCOPES.GESTION_USUARIOS_LOCATARIO]} >
                <UserIdAuthorized>

                    <PageTitle>
                        {title}
                    </PageTitle>

                    <div className="row">
                        <div className="col-md-6">
                            <div className="card card-flush h-md-100 pt-3">
                                <div className="card-header">

                                    <div className="card-title">
                                        <h2>Administrador</h2>
                                    </div>

                                </div>
                                <div className="card-body pt-2">
                                    <div className="d-flex flex-column mb-5 fv-row fv-plugins-icon-container">
                                        <label className="required fs-5 fw-bold mb-2">Email</label>

                                        <input className="form-control form-control-solid"
                                            value={dataGetUsuarios.administrador.correo}
                                            onChange={(e) =>
                                                setDataGetUsuarios(
                                                    {
                                                        ...dataGetUsuarios,
                                                        administrador: {
                                                            ...dataGetUsuarios.administrador, correo: e.target.value
                                                        }
                                                    }
                                                )
                                            }
                                        />

                                    </div>
                                    <div className="d-flex flex-column mb-5 fv-row fv-plugins-icon-container">
                                        <label className="required fs-5 fw-bold mb-2">Usuario</label>

                                        <input className="form-control form-control-solid"
                                            value={dataGetUsuarios.administrador.nombreCompleto}
                                            onChange={(e) =>
                                                setDataGetUsuarios(
                                                    {
                                                        ...dataGetUsuarios,
                                                        administrador: {
                                                            ...dataGetUsuarios.administrador, nombreCompleto: e.target.value
                                                        }
                                                    }
                                                )
                                            }
                                        />

                                    </div>
                                    <div className="d-flex flex-column mb-5 fv-row fv-plugins-icon-container">
                                        <label className="required fs-5 fw-bold mb-2">Contraseña</label>
                                        <input type="password"
                                            className="form-control form-control-solid"
                                            value={dataGetUsuarios.administrador.contrasenia}
                                            onChange={(e) =>
                                                setDataGetUsuarios(
                                                    {
                                                        ...dataGetUsuarios,
                                                        administrador: {
                                                            ...dataGetUsuarios.administrador, contrasenia: e.target.value
                                                        }
                                                    }
                                                )
                                            }
                                        />

                                    </div>

                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 mt-6 mt-md-0">
                            <div className="card card-flush h-md-100 pt-3">
                                <div className="card-header">

                                    <div className="card-title">
                                        <h2>Operador</h2>
                                    </div>

                                </div>


                                <div className="card-body pt-2">
                                    <div className="d-flex flex-column mb-5 fv-row fv-plugins-icon-container">
                                        <label className="required fs-5 fw-bold mb-2">Email</label>

                                        <input className="form-control form-control-solid"
                                            value={dataGetUsuarios.operador.correo}
                                            onChange={(e) =>
                                                setDataGetUsuarios(
                                                    {
                                                        ...dataGetUsuarios,
                                                        operador: {
                                                            ...dataGetUsuarios.operador, correo: e.target.value
                                                        }
                                                    }
                                                )
                                            }
                                        />

                                    </div>
                                    <div className="d-flex flex-column mb-5 fv-row fv-plugins-icon-container">
                                        <label className="required fs-5 fw-bold mb-2">Usuario</label>
                                        <input className="form-control form-control-solid"
                                            value={dataGetUsuarios.operador.nombreCompleto}
                                            onChange={(e) =>
                                                setDataGetUsuarios(
                                                    {
                                                        ...dataGetUsuarios,
                                                        operador: {
                                                            ...dataGetUsuarios.operador, nombreCompleto: e.target.value
                                                        }
                                                    }
                                                )
                                            }
                                        />

                                    </div>
                                    <div className="d-flex flex-column mb-5 fv-row fv-plugins-icon-container">
                                        <label className="required fs-5 fw-bold mb-2">Contraseña</label>
                                        <input type="password"
                                            className="form-control form-control-solid"
                                            value={dataGetUsuarios.operador.contrasenia}
                                            onChange={(e) =>
                                                setDataGetUsuarios(
                                                    {
                                                        ...dataGetUsuarios,
                                                        operador: {
                                                            ...dataGetUsuarios.operador, contrasenia: e.target.value
                                                        }
                                                    }
                                                )
                                            }
                                        />

                                    </div>

                                </div> </div>
                        </div>
                        <div className="col-md-6 mt-6">
                            <div className="card card-flush h-md-100 pt-3">
                                <div className="card-header">

                                    <div className="card-title">
                                        <h2>Financiero 1</h2>
                                    </div>

                                </div>

                                <div className="card-body pt-2">
                                    <div className="d-flex flex-column mb-5 fv-row fv-plugins-icon-container">
                                        <label className="required fs-5 fw-bold mb-2">Email</label>

                                        <input className="form-control form-control-solid"
                                            value={dataGetUsuarios.financiero1.correo}
                                            onChange={(e) =>
                                                setDataGetUsuarios(
                                                    {
                                                        ...dataGetUsuarios,
                                                        financiero1: {
                                                            ...dataGetUsuarios.financiero1, correo: e.target.value
                                                        }
                                                    }
                                                )
                                            }
                                        />

                                    </div>
                                    <div className="d-flex flex-column mb-5 fv-row fv-plugins-icon-container">
                                        <label className="required fs-5 fw-bold mb-2">Usuario</label>
                                        <input className="form-control form-control-solid"
                                            value={dataGetUsuarios.financiero1.nombreCompleto}
                                            onChange={(e) =>
                                                setDataGetUsuarios(
                                                    {
                                                        ...dataGetUsuarios,
                                                        financiero1: {
                                                            ...dataGetUsuarios.financiero1, nombreCompleto: e.target.value
                                                        }
                                                    }
                                                )
                                            }
                                        />

                                    </div>
                                    <div className="d-flex flex-column mb-5 fv-row fv-plugins-icon-container">
                                        <label className="required fs-5 fw-bold mb-2">Contraseña</label>
                                        <input type="password"
                                            className="form-control form-control-solid"
                                            value={dataGetUsuarios.financiero1.contrasenia}
                                            onChange={(e) =>
                                                setDataGetUsuarios(
                                                    {
                                                        ...dataGetUsuarios,
                                                        financiero1: {
                                                            ...dataGetUsuarios.financiero1, contrasenia: e.target.value
                                                        }
                                                    }
                                                )
                                            }
                                        />

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 mt-6">
                            <div className="card card-flush h-md-100 pt-3">
                                <div className="card-header">

                                    <div className="card-title">
                                        <h2>Financiero 2</h2>
                                    </div>

                                </div>

                                <div className="card-body pt-2">
                                    <div className="d-flex flex-column mb-5 fv-row fv-plugins-icon-container">
                                        <label className="required fs-5 fw-bold mb-2">Email</label>

                                        <input className="form-control form-control-solid"
                                            value={dataGetUsuarios.financiero2.correo}
                                            onChange={(e) =>
                                                setDataGetUsuarios(
                                                    {
                                                        ...dataGetUsuarios,
                                                        financiero2: {
                                                            ...dataGetUsuarios.financiero2, correo: e.target.value
                                                        }
                                                    }
                                                )
                                            }
                                        />

                                    </div>
                                    <div className="d-flex flex-column mb-5 fv-row fv-plugins-icon-container">
                                        <label className="required fs-5 fw-bold mb-2">Usuario</label>
                                        <input className="form-control form-control-solid"
                                            value={dataGetUsuarios.financiero2.nombreCompleto}
                                            onChange={(e) =>
                                                setDataGetUsuarios(
                                                    {
                                                        ...dataGetUsuarios,
                                                        financiero2: {
                                                            ...dataGetUsuarios.financiero2, nombreCompleto: e.target.value
                                                        }
                                                    }
                                                )
                                            }
                                        />

                                    </div>
                                    <div className="d-flex flex-column mb-5 fv-row fv-plugins-icon-container">
                                        <label className="required fs-5 fw-bold mb-2">Contraseña</label>
                                        <input type="password"
                                            className="form-control form-control-solid"
                                            value={dataGetUsuarios.financiero2.contrasenia}
                                            onChange={(e) =>
                                                setDataGetUsuarios(
                                                    {
                                                        ...dataGetUsuarios,
                                                        financiero2: {
                                                            ...dataGetUsuarios.financiero2, contrasenia: e.target.value
                                                        }
                                                    }
                                                )
                                            }
                                        />

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="card-px text-center pt-15 pb-15">

                            <button type="submit" className="btn btn-primary" onClick={() => setUpdateCierre(true)}>Registrar</button>
                            {isLoading2 && <span style={{ marginLeft: 15 }}><Loading /></span>}

                        </div>
                    </div>



                    <Modal
                        size="sm"
                        show={guardadoExitoso}
                        onHide={() => setGuardadoExitoso(false)}
                        aria-labelledby="contained-modal-title-vcenter"
                        centered
                    >
                        <Modal.Header>
                            <Modal.Title id="example-modal-sizes-title-sm" style={{ margin: 'auto' }}>
                                Guardado Exitoso
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Footer style={{ margin: 'auto' }}>
                            <button type="button" className="btn btn-primary" onClick={guardadoExistosoModal}>
                                Aceptar
                            </button>
                        </Modal.Footer>
                    </Modal>


                </UserIdAuthorized>
            </PermissionsGate>
        </>
    )
}